<template>
    <div>
        <image-button
                @click.native="showModal = true"
                img="/images/svg/ATS3bdSeriesicon_for.svg">
            forecast time series
        </image-button>

        <portal to="modals" v-if="showModal">
            <modal-bottom v-if="showModal" @close="close()" class="bg-grey-lighter">
                <h3 slot="header">Interpolate Missing Values</h3>

                <div slot="save" v-show="action !== null">
                    <a class="cursor-pointer inline-block bg-blue text-white px-4 py-2 rounded" v-show="true"
                       @click="save()">
                        Apply
                    </a>
                </div>

                <!--
                <p class="text-grey-darker text-sm">
                                    In order to forecast the time series selected two methods are available here:<br>
                                    - Extrapolate(linear): known as "method of least squares" <br>
                                    - Extrapolate(constant):
                                    interpretation of values in tiers before the first known data point or after the
                                    last known data point
                                    here the constant extrapolation iterates the first/last known values to bring all
                                    time series selected to the same length.<br>
                                    example: series ONE starts with value A two periods later than series TWO which is
                                    two periods shorter than the fist one and ends with value B
                                    so series ONE will be extrapolated twice at the beginning by value A each and series
                                    TWO is extrapolated twice at its end by value B
                                </p>
                -->

                <p>Forecast method:</p>

                <button class="bg-white cursor-pointer text-center p-4 mr-4 mb-4 border-2 border-white hover:bg-blue-lightest shadow rounded hover:border-blue-dark"
                        :class="{'bg-blue-lightest border-blue-dark': action === 'linear'}"
                        @click="action = 'linear'">
                    Linear
                </button>

                <button class="bg-white cursor-pointer text-center p-4 mr-4 mb-4 border-2 border-white hover:bg-blue-lightest shadow rounded hover:border-blue-dark"
                        :class="{'bg-blue-lightest border-blue-dark': action === 'constant'}"
                        @click="action = 'constant'">
                    Constant
                </button>

                <div class="mt-2" v-show="action !== null">
                    <p>Extrapolate until:</p>

                    <input type="range" min="0" max="100" v-model="steps"> <span class="text-grey">{{ steps }}</span>
                </div>

                <div class="mt-2" v-show="action === 'linear'">
                    <p>Span:</p>

                    <input type="range" min="0" max="100" v-model="span"> <span class="text-grey">{{ span }}</span>
                </div>


            </modal-bottom>
        </portal>

    </div>
</template>

<script>

    import ImageButton from "../ImageButton";
    import ModalBottom from "../ModalBottom";
    import ExtrapolateConstantModifier from "../../modifiers/ExtrapolateConstantModifier";
    import ExtrapolateLinearModifier from "../../modifiers/ExtrapolateLinearModifier";

    export default {
        name: "ComputeForecast",

        components: {ModalBottom, ImageButton},

        data: () => ({
            showModal: false,
            action: null,
            time: null,
            steps: 5,
            span: 1,
        }),

        computed: {
            selected() {
                return this.$store.state.rawData.data[this.$store.state.periodicity].data.map(function (item, index) {
                    return index;
                });
            },
        },

        watch: {
            action() {
                this.modify();
            },
            steps() {
                this.modify();
            },
            span() {
                this.modify();
            },
            showModal() {
                this.action = null;
            },
        },

        methods: {
            close() {
                this.$store.dispatch('abort');
                this.showModal = false;
            },
            modify() {
                if (this.action === 'linear') {
                    this.$store.dispatch('setModifier', {
                        modifier: new ExtrapolateLinearModifier({
                            steps: this.steps,
                            span: this.span,
                        }),
                        ids: this.selected
                    });
                }

                if (this.action === 'constant') {
                    this.$store.dispatch('setModifier', {
                        modifier: new ExtrapolateConstantModifier({
                            steps: this.steps,
                        }),
                        ids: this.selected
                    });
                }

                if (this.action === null) {
                    this.$store.dispatch('abort');
                }
            },
            save() {
                this.$store.dispatch('save');
                this.showModal = false;
            }
        }
    }
</script>

<style scoped>

</style>
